module.exports = __webpack_public_path__ + "img/252.d0b9707f.png";